const getConditionId = conditionPath => conditionPath.join('__');
export default getConditionId;